import { cartActions } from './model';

export * from './model/selectors';
export * from './model/thunks';

export { cartReducer } from './model';

export { schema, createName } from './lib';

export const {
	openCart,
	closeCart,
	clearCart,
	changeItemQuantity,
	changeAmount,
	changeCity,
	changePoint,
	changeMetadata,
	changeStatus,
} = cartActions;
